import { z } from 'zod';
/* ==========================================================================
 *  User mention override wire contract (ISSUE-025)
 *  Override endpoints: GET /me/overrides, DELETE /me/overrides/:id
 * ========================================================================== */
export const overrideViewSchema = z.object({
    id: z.string().uuid(),
    alias: z.string(),
    resolvedFoodId: z.string().nullable(),
    resolvedFoodName: z.string().nullable(),
    createdAt: z.string().datetime(),
});
export const listOverridesResponseSchema = z.object({
    overrides: z.array(overrideViewSchema),
});
//# sourceMappingURL=override.js.map